import Singleton from '../Singleton';
import CoreAppService from '../_shared/api/coreAppService';
import { RetailMedia, RetailCreateRequest } from '../global.d';
import TradeDetails from '../_shared/models/TradeDetails';
import { RETAIL_INPUTS } from '../_shared/constants/retail';
import { localStorageService } from './StorageService';
import LOCALSTORAGE from '../_shared/constants/localStorage';
import renderLocale from '../_shared/helpers/renderLocale';

export default class RetailService extends Singleton<RetailService> {
  static createRetailCase = async (
    tradeId,
    retailInputRequest,
    tradeDetails: TradeDetails,
    canSell: Boolean,
    medialist
  ) => {
    if (!tradeId && !tradeDetails) {
      return null;
    }
    let retailDataResponse;
    try {
      const client = await CoreAppService();
      const retailRequest = RetailService.buildRetailCreateRequest(
        retailInputRequest,
        tradeDetails,
        medialist,
        canSell
      );
      retailDataResponse = await client.retail.create(tradeId, retailRequest);
      localStorageService.setItem(
        LOCALSTORAGE.RETAIL_TRADE,
        retailDataResponse?.data
      );
    } catch (exp) {
      return exp?.response?.data;
    }
    return retailDataResponse?.data;
  };

  static getRetailCase = async (retailGuid: string) => {
    if (!retailGuid) {
      return null;
    }

    const retailTradeInLocalStore = localStorageService.getItem(
      LOCALSTORAGE.RETAIL_TRADE
    );
    const locale = renderLocale();
    if (
      retailTradeInLocalStore?.guid === retailGuid &&
      retailTradeInLocalStore?.locale === locale
    ) {
      return retailTradeInLocalStore;
    }
    localStorageService.removeItem(LOCALSTORAGE.RETAIL_TRADE);
    let retailDataResponse;
    try {
      const client = await CoreAppService();
      retailDataResponse = await client.retail.fetchRetailTrade(retailGuid);
      localStorageService.setItem(LOCALSTORAGE.RETAIL_TRADE, {
        ...retailDataResponse?.data,
        locale
      });
    } catch (exp) {
      return undefined;
    }
    return retailDataResponse?.data;
  };

  static buildRetailMediaRequest = (mediaList): RetailMedia[] => {
    const retailMediaList =
      mediaList?.filter(media => media.isChecked === true) || [];
    return retailMediaList;
  };

  static buildRetailCreateRequest = (
    retailInputRequest,
    tradeDetails,
    medialist,
    canSell
  ): RetailCreateRequest => {
    return {
      media: RetailService.buildRetailMediaRequest(medialist) || [],
      tradeDetails: {
        year: tradeDetails.year,
        make: tradeDetails.manufacturerName,
        model: tradeDetails.modelName,
        trim: tradeDetails.trim,
        odometerDisplay: tradeDetails.odometerDisplay,
        transmission: tradeDetails.transmission,
        engine: `${tradeDetails.displacement}, ${tradeDetails.cylinders}`,
        driveTrain: tradeDetails.driveTrain,
        fuelType: tradeDetails.fuelType,
        seats: tradeDetails.passengers,
        extIntColor: `${tradeDetails.exteriorColor} / ${tradeDetails.interiorColor}`,
        vehicleHistoryReportUrl: tradeDetails.vehicleHistoryReportUrl,
        vin: tradeDetails.vin,
        vehicleOptions: tradeDetails.options?.toString()
      },
      retailTradeMetadata: {
        customerPrice: retailInputRequest[RETAIL_INPUTS.PRICE],
        notes: retailInputRequest[RETAIL_INPUTS.NOTES],
        salePersonName: retailInputRequest[RETAIL_INPUTS.NAME],
        salePersonEmail: retailInputRequest[RETAIL_INPUTS.EMAIL],
        salePersonPhone: retailInputRequest[RETAIL_INPUTS.PHONE],
        dealershipLink: retailInputRequest[RETAIL_INPUTS.INVENTORY]
      },
      blurBackground: false,
      canSell
    };
  };
}
